/** @format */

// import { findTreeDataByAll, findTreeDataByTheRole, findTreeDataByRole } from '@/api/platform/org/role'
import { queryWithSys as findTreeDataByAll } from '@/api/position/index';
import { ActionUtils } from '@/utils/action';

export default {
	methods: {
		findTreeDataTypes(type, params, methods) {
			return new Promise((resolve, reject) => {
				switch (type) {
					case '1':
						methods
							.findTreeDataByAll({ params })
							.then((data) => {
								resolve(data);
							})
							.catch(() => {
								reject([]);
							});
						break;
					case '2':
						methods
							.findTreeDataByTheRole({ params })
							.then((data) => {
								resolve(data);
							})
							.catch(() => {
								reject([]);
							});
						break;
					case '3':
						methods
							.findTreeDataByRole({ params })
							.then((data) => {
								resolve(data);
							})
							.catch(() => {
								reject([]);
							});
						break;
				}
			});
		},
		// 查询全部-1
		findTreeDataByAll(paramsOptions) {
			const params = paramsOptions.params;
			return new Promise((resolve, reject) => {
				findTreeDataByAll(ActionUtils.formatParams(params))
					.then((res) => {
						resolve(res);
					})
					.catch(() => {
						reject([]);
					});
			});
		},

		// 查询当前-2
		// findTreeDataByTheRole(paramsOptions) {
		// 	const params = paramsOptions.params;
		// 	return new Promise((resolve, reject) => {
		// 		findTreeDataByTheRole(params)
		// 			.then((res) => {
		// 				resolve(res.data);
		// 			})
		// 			.catch(() => {
		// 				reject([]);
		// 			});
		// 	});
		// },
		// 查询指定-3
		// findTreeDataByRole(paramsOptions) {
		// 	const params = paramsOptions.params;
		// 	return new Promise((resolve, reject) => {
		// 		findTreeDataByRole(params)
		// 			.then((res) => {
		// 				resolve(res.data);
		// 			})
		// 			.catch(() => {
		// 				reject([]);
		// 			});
		// 	});
		// },
	},
};
